<template>
  <ExtracadabraModal
    v-model:opened="internalOpen"
    :header="{
      img: 'interrogation_mark.svg',
      bgColor: 'primary',
      textColor: 'white',
    }"
    :footer="{ class: 'text-center q-pb-lg' }"
    size="md"
  >
    <template #body>
      <h3 class="text-h3 q-pb-lg text-center">
        {{ $t("ETAB.PAGES.EXTRA.@MOTIVATION_TITLE_SHORT") }}
      </h3>
      {{ motivationText }}
    </template>
    <template #footer>
      <QBtn v-close-popup color="secondary" no-caps class="btn-large" :label="$t('ETAB.PAGES.EXTRA.@BACK_TO_PROFILE')" />
    </template>
  </ExtracadabraModal>
</template>

<script>
  import ExtracadabraModal from "@core/components/modals/ExtracadabraModal.component.vue";

  export default {
    components: { ExtracadabraModal },
    props: {
      motivationText: {
        type: String,
        default: "",
      },
      opened: {
        type: Boolean,
        default: false,
      },
    },
    emits: ["update:opened"],
    computed: {
      internalOpen: {
        get() {
          return this.opened;
        },
        set(value) {
          this.$emit("update:opened", value);
        },
      },
    },
  };
</script>
